import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// World currencies — code, name, symbol, optional locale for thousands formatting
export const CURRENCIES = [
  { code: "PKR", name: "Pakistani Rupee", symbol: "₨", locale: "en-PK" },
  { code: "USD", name: "US Dollar", symbol: "$", locale: "en-US" },
  { code: "EUR", name: "Euro", symbol: "€", locale: "en-IE" },
  { code: "GBP", name: "British Pound", symbol: "£", locale: "en-GB" },
  { code: "AED", name: "UAE Dirham", symbol: "د.إ", locale: "en-AE" },
  { code: "SAR", name: "Saudi Riyal", symbol: "﷼", locale: "en-SA" },
  { code: "INR", name: "Indian Rupee", symbol: "₹", locale: "en-IN" },
  { code: "BDT", name: "Bangladeshi Taka", symbol: "৳", locale: "en-BD" },
  { code: "CAD", name: "Canadian Dollar", symbol: "C$", locale: "en-CA" },
  { code: "AUD", name: "Australian Dollar", symbol: "A$", locale: "en-AU" },
  { code: "SGD", name: "Singapore Dollar", symbol: "S$", locale: "en-SG" },
  { code: "MYR", name: "Malaysian Ringgit", symbol: "RM", locale: "en-MY" },
  { code: "JPY", name: "Japanese Yen", symbol: "¥", locale: "ja-JP" },
  { code: "CNY", name: "Chinese Yuan", symbol: "¥", locale: "zh-CN" },
  { code: "TRY", name: "Turkish Lira", symbol: "₺", locale: "tr-TR" },
  { code: "ZAR", name: "South African Rand", symbol: "R", locale: "en-ZA" },
  { code: "NGN", name: "Nigerian Naira", symbol: "₦", locale: "en-NG" },
  { code: "KES", name: "Kenyan Shilling", symbol: "KSh", locale: "en-KE" },
  { code: "EGP", name: "Egyptian Pound", symbol: "£", locale: "en-EG" },
  { code: "QAR", name: "Qatari Riyal", symbol: "﷼", locale: "en-QA" },
];

export const DEFAULT_CURRENCY = CURRENCIES[0]; // PKR

export function getCurrency(code) {
  if (!code) return DEFAULT_CURRENCY;
  return CURRENCIES.find((c) => c.code === code) || DEFAULT_CURRENCY;
}

// Generic money formatter — uses the currency symbol if provided, else PKR.
export function formatMoney(n, symbol, locale) {
  const num = Number(n || 0);
  const sym = symbol || DEFAULT_CURRENCY.symbol;
  const loc = locale || DEFAULT_CURRENCY.locale;
  return `${sym} ${num.toLocaleString(loc, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Back-compat alias — defaults to PKR.
export function formatPKR(n) {
  return formatMoney(n, DEFAULT_CURRENCY.symbol, DEFAULT_CURRENCY.locale);
}
